import { useQuery } from '@tanstack/react-query';
import {
  defaultPreservationGridSort,
  strapiListPreservationGridRows,
  type PreservationGridSort,
} from '../../api/strapiCrm';
import { queryKeys } from '../queryKeys';

export function usePreservationGridRowsQuery(
  jwt: string | null,
  sort: PreservationGridSort = defaultPreservationGridSort,
) {
  return useQuery({
    queryKey: queryKeys.preservationGridRows(jwt, sort),
    queryFn: () => strapiListPreservationGridRows(jwt!, sort),
    enabled: Boolean(jwt),
    // Grid changes via receive/sign mutations (those already invalidate this key).
    staleTime: 30 * 60 * 1000,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
}
